import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const SimulatorContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.white};
`;

export const SimulatorWrapper = styled.div`
  margin-bottom: 30px;
`;

export const SimulatorHeader = styled.div``;

export const SimulatorHaderGrid = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SimulatorHaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
  text-transform: uppercase;
`;

export const SimulatorSelectShowOptionSelectContent = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

export const SimulatorSelectShowOptionLabel = styled.span`
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  text-transform: uppercase;
`;

export const SimulatorSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const SimulatorSelectShowOptionSelect = styled.div`
  margin-top: 5px;
  width: 100%;
  max-width: 210px;
  position: relative;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  svg {
    transform: ${prop => prop.open ? 'none' : 'rotate(180deg) !important'};
    transition: ease-in-out .2s;
  }
`;

export const SimulatorSelectShowOptionSelected = styled.span`
  font-size: 14px;
  color: ${colors.bgPrimary};
  line-height: 20px;
  text-align: right;
  margin-right: 10px;

  &.default {
    color: ${colors.textSecondary};
    margin-right: 0px;
  }
`;

export const SimulatorSelectShowOptionContent = styled.div`
  width: 100%;
  max-width: 210px;
  left: -100px;
  position: absolute;
  display: block;
  top: 25px;
  display: flex;
  overflow-y: scroll;
  overflow-x: hidden;
  flex-direction: column; 
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  max-height: 210px;
  overflow: ${prop => prop.open ? '' : 'hidden'};
  transition: ease-in-out .2s;
  z-index: 5;
  min-width: 210px;
  text-align: left;

  &::-webkit-scrollbar {
    width: 4px;
    background: ${colors.bgScreen}; 
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.bgSecondary}; 
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.bgDanger}; 
  }
`;

export const SimulatorSelectShowOptionSelectOption = styled.div`
  padding: 10px;
  background: ${prop => prop.active ? colors.bgSecondaryHover : colors.white};
  transition: ease-in-out .2s;

  &:hover {
    background: ${colors.bgSuccess};
  }

  &:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const SimulatorContent = styled.div`
  /*margin-top: 40px;
  display: grid;
  */
`;

export const SimulatorSteps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: end;
`;

export const SimulatorStepsStatus = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 10px; 
  }
`;

export const SimulatorStepsStepCircle = styled.div`
  min-width: 50px;
  min-height: 50px;
  border-radius: 25px;
  border: 2px solid ${prop => prop.finish ? colors.bgPrimaryLight : prop.active ? colors.bgPrimaryLight : colors.grayLight};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.finish ? colors.bgPrimaryLight : prop.active ? colors.white : colors.grayLight};
  color: ${prop => prop.active ? colors.bgPrimaryLight : colors.white};
  font-weight: 600;
`;

export const SimulatorStepsLabel = styled.span`
  margin-right: 29px;
`;

export const SimulatorStepsStatusBar = styled.div`
  width: 2px;
  height: 40px;
  background: ${prop => prop.finish ? colors.bgPrimaryLight : colors.grayLight};
  margin-right: 25px;
`;

export const SimulatorSelectLabel = styled.span`
  text-transform: uppercase;
  color: ${colors.textPrimary};
  font-size: 12px;
  line-height: 14px;
  text-align: right;
`;

export const SimulatorSelectOfficeImg = styled.img`
  margin:15px;
  position: center;
`;

export const SimulatorSelectOficeLabel = styled.span`
  display:block;
  white-space: nowrap;
  color: ${colors.darkblue};
  font-family: Montserrat;
  font-weight: bold;
  font-size: 32px; 
  line-height: 39px;
  margin-bottom:10px;
`;

export const SimulatorSelectOficeLabelBlack = styled.span`
  margin:15px;
  display:block;
  white-space: nowrap;
  color: ${colors.textPrimary};
  font-family: Montserrat;
  font-size: 18px;
  font-weight: regular;
  line-height: 22px;
  letter-spacing: 0em;
`;

export const SimulatorSubSelectOficeLabelBlack = styled.span`
  color: ${colors.textPrimary};
  font-family: Montserrat;
  font-size: 16px;
`;


export const Container = styled.div`
  width: 80%;
  height:40%;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const SimulatorSelectShowOptionSelectedMessageError = styled.div`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 0px;
  opacity: ${prop => prop.error ? '1' : '0'};
  transition: ease-in-out .2s;
`;

export const SimulatorSelectActiveOption = styled.span`
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  font-size: 16px;
  line-height: 23px;
`;
